import {
  DeleteOutlined,
  EditOutlined,
  MoreOutlined,
  QuestionCircleOutlined,
} from '@ant-design/icons'
import { Button, Col, Dropdown, Menu, message, Modal, Row } from 'antd'
import FileDownload from 'js-file-download'
import { inject, observer } from 'mobx-react'
import moment from 'moment'
import React, { memo, useCallback, useEffect, useMemo, useState } from 'react'
import { Helmet } from 'react-helmet/es/Helmet'
import { useMediaQuery } from 'react-responsive'
import { blue } from '../../../color'
import FileItem from '../../../components/Common/FileItemComponent/FileItem'
import ContentBlockWrapper from '../../../components/ContentBlockWrapper'
import PageTitle from '../../../components/PageTitle'
import PDFViewer from '../../../components/PDFViewer'
import { ACL_ACTION_TYPE, DATE_FORMAT_DEFAULT } from '../../../constants'
import DashboardLayout from '../../../layouts/DashboardLayout'
import utils from '../../../utils'
import {
  DocumentInfoContent,
  FileViewBlock,
  HeadingButtonWrapper,
  TitleBlock,
  ValueBlock,
  ViewDetailContent,
} from './BoardResolutionMinutesDetailStyled'
import { ArrowLeftBroken, MenuDotsBoldIcon } from '../../../components/AppIcon'
import AppPageHeader from '../../../components/AppPageHeader'

const { confirm } = Modal

const BoardResolutionMinutesDetail = props => {
  const {
    loadingAnimationStore,
    boardResolutionMinutesStore,
    history,
    match,
    aclStore,
  } = props

  const [attachmentForView, setAttachmentForView] = useState()

  const isTabletOrMobile = useMediaQuery({
    query: '(max-width: 1299px)',
  })

  const { documentId } = match.params
  const { BoardHDQTDetail } = boardResolutionMinutesStore
  const {
    id,
    document_name,
    document_number,
    contruction_board,
    issue_date,
    status,
    issue_level,
    attachments_minutes,
    attachments_resolution,
    attachments,
  } = BoardHDQTDetail

  const downloadFile = useCallback(
    (id, file_id, file_name) => {
      loadingAnimationStore.showSpinner(true)
      boardResolutionMinutesStore
        .getAttachmentBoardHDQT({
          recordId: id,
          fileId: file_id,
        })
        .then(response => {
          loadingAnimationStore.showSpinner(false)
          const blob = new Blob([response.data], { type: 'application/pdf' })
          FileDownload(blob, `${file_name}`)
        })
        .catch(() => {
          loadingAnimationStore.showSpinner(false)
        })
    },
    [boardResolutionMinutesStore, loadingAnimationStore]
  )

  useEffect(() => {
    let isCancelled = false
    ;(async () => {
      loadingAnimationStore.showSpinner(true)
      try {
        await boardResolutionMinutesStore.getBoardResolutionMinutesDetail(
          documentId
        )
      } catch (err) {
        history.replace('/board-resolution-minutes-hdqt')
        console.log(err)
        message.error(err?.vi || 'Đã có lỗi xảy ra!')
      } finally {
        if (!isCancelled) loadingAnimationStore.showSpinner(false)
      }
    })()
    return () => {
      isCancelled = true
      boardResolutionMinutesStore.clearBoardHDQTDetail()
    }
  }, [documentId])

  const handleDeleteDocument = async () => {
    loadingAnimationStore.showSpinner(true)
    try {
      await boardResolutionMinutesStore.deleteBoardResolutionMinutes(documentId)
      history.push('/board-resolution-minutes-hdqt')
      message.success('Xóa biên bản nghị quyết thành công')
    } catch (err) {
      console.log(err)
      message.error(err.vi || 'Đã có lỗi xảy ra')
    } finally {
      loadingAnimationStore.showSpinner(false)
    }
  }

  const showConfirm = () => {
    confirm({
      title: 'Bạn có muốn xóa biên bản này không?',
      icon: <QuestionCircleOutlined style={{ color: 'red' }} />,
      okText: 'Đồng ý',
      cancelText: 'Không',
      okType: 'danger',
      onOk() {
        handleDeleteDocument()
      },
    })
  }

  useEffect(() => {
    if (!attachments) return
    setAttachmentForView(
      attachments.find(file =>
        ['pdf', 'doc', 'docx'].includes(utils.getExtensionFile(file.name))
      )
    )
  }, [attachments])

  const renderAttachment = useMemo(
    () => (
      <PDFViewer
        key={attachmentForView?.id}
        fileId={attachmentForView?.id}
        customStyleObj={{ height: isTabletOrMobile ? 500 : 1000 }}
        fileType={utils.getExtensionFile(attachmentForView?.name)}
      />
    ),
    [attachmentForView]
  )

  const menuHandleDocument = (
    <Menu>
      {aclStore.checkAccessControlAction(ACL_ACTION_TYPE.edit__BB_NQ_HDQT) && (
        <Menu.Item
          key={1}
          onClick={() =>
            history.push(`/board-resolution-minutes-hdqt/${documentId}`)
          }
          icon={<EditOutlined style={{ color: blue }} />}>
          <span style={{ color: blue }}>Chỉnh sửa biên bản</span>
        </Menu.Item>
      )}
      {aclStore.checkAccessControlAction(
        ACL_ACTION_TYPE.delete__BB_NQ_HDQT
      ) && (
        <Menu.Item
          key={2}
          danger
          onClick={showConfirm}
          icon={<DeleteOutlined />}>
          Xóa biên bản
        </Menu.Item>
      )}
    </Menu>
  )

  const renderFileItem = fileId => {
    const att = (attachments || []).find(a => a.id === fileId)
    const fileName = att?.name || fileId
    const fileType = utils.getExtensionFile(fileName)

    return (
      <FileItem
        key={fileId}
        file_id={fileId}
        file_name={fileName}
        file_type={fileType}
      />
    )
  }

  const renderViewContent = () => (
    <Row type={'flex'} gutter={30} style={{ height: '100%' }}>
      <Col span={24} xs={24} md={16}>
        {<FileViewBlock>{renderAttachment}</FileViewBlock>}
      </Col>
      <Col span={24} xs={24} md={8}>
        <div className="custom-create-page-content-wrapper">
          <h3 style={{ marginBottom: 16, fontSize: 18, fontWeight: 600 }}>
            Thông tin chung
          </h3>
          <DocumentInfoContent>
            <Row>
              <TitleBlock>
                <strong>Tên văn bản:</strong>
              </TitleBlock>
              <ValueBlock>{document_name}</ValueBlock>
            </Row>

            <Row>
              <TitleBlock>
                <strong>Số quyết định ban hành:</strong>
              </TitleBlock>
              <ValueBlock>{document_number}</ValueBlock>
            </Row>

            <Row>
              <TitleBlock>
                <strong>Ngày ban hành:</strong>
              </TitleBlock>
              <ValueBlock>
                {moment(issue_date).format(DATE_FORMAT_DEFAULT)}
              </ValueBlock>
            </Row>

            {/* <Row>
              <TitleBlock>
                <strong>Cấp ban hành:</strong>
              </TitleBlock>
              <ValueBlock>{issue_level || '-'}</ValueBlock>
            </Row> */}

            <Row>
              <TitleBlock>
                <strong>Ban chủ trì xây dựng:</strong>
              </TitleBlock>
              <ValueBlock>{contruction_board || '-'}</ValueBlock>
            </Row>

            {/* <Row>
              <TitleBlock>
                <strong>Trạng thái:</strong>
              </TitleBlock>
              <ValueBlock>
                {{
                  ABOLISHED: 'Đã bãi bỏ',
                  EXPIRED: 'Hết hiệu lực',
                  ACTIVE: 'Còn hiệu lực',
                }[status] || ''}
              </ValueBlock>
            </Row> */}

            <Row>
              <Col style={{ width: '100%' }}>
                {Array.isArray(attachments_minutes) &&
                  attachments_minutes.length > 0 && (
                    <>
                      <strong>Biên bản:</strong>
                      {attachments_minutes.map(fileId =>
                        renderFileItem(fileId)
                      )}
                    </>
                  )}
                {Array.isArray(attachments_resolution) &&
                  attachments_resolution.length > 0 && (
                    <>
                      <strong style={{ marginTop: 8, display: 'block' }}>
                        Nghị quyết:
                      </strong>
                      {attachments_resolution.map(fileId =>
                        renderFileItem(fileId)
                      )}
                    </>
                  )}
              </Col>
            </Row>
          </DocumentInfoContent>
        </div>
      </Col>
    </Row>
  )

  return (
    <DashboardLayout>
      <Helmet>
        <title>Chi tiết biên bản nghị quyết</title>
      </Helmet>

      <AppPageHeader
        title={document_name}
        showBackButton
        addon={
          <Dropdown overlay={menuHandleDocument} trigger={['click']}>
            <Button
              style={{ width: 40, height: 40, flexShrink: 0 }}
              icon={
                <MenuDotsBoldIcon
                  style={{ width: 20, height: 20, transform: 'rotate(90deg)' }}
                />
              }
              className="custom-ant-button icon-btn"
              type="default"
            />
          </Dropdown>
        }
      />
      <ViewDetailContent>{renderViewContent()}</ViewDetailContent>
    </DashboardLayout>
  )
}

BoardResolutionMinutesDetail.propTypes = {}

export default memo(
  inject(
    'loadingAnimationStore',
    'commonStore',
    'documentStore',
    'aclStore',
    'boardResolutionMinutesStore'
  )(observer(BoardResolutionMinutesDetail))
)
